import React, { useMemo } from 'react';
import { LinkElement } from '@els/els-react--link-element';
import { personalizationHelpUrl } from '@Constants/CommonConstants';
import Auth from '@Services/Auth';
import './TexelBanner.scss';

function TexelBanner() {
  const isAnonymous = useMemo(() => Auth.isAnonymousUser(), []);

  return (
    <section className="quick-search-texel-banner u-els-padding-2x u-els-font-size-h4 u-els-line-height-heading">
      <div className="quick-search-texel-banner__content u-els-text-center">
        <strong>
          Discover a more intuitive way to search — with Reaxys AI Search <i>Beta.</i>
        </strong>
        {isAnonymous ? (
          <>
            <br />
            The AI Search tab appears after you log in or register.
            <br />
            Using Reaxys through your institution? If the tab isn’t visible, click <i>Activate Personalization</i> in your profile menu.{' '}
            <LinkElement href={personalizationHelpUrl} isExternal noExternalIcon inline>
              Learn more
            </LinkElement>
          </>
        ) : null}
      </div>
    </section>
  );
}

export default TexelBanner;
